export default __webpack_public_path__ + "static/media/htp2n.d498569c.png";